module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withHeader) ? _c('v-system-bar', {
    staticStyle: {
      "position": "inherit"
    },
    attrs: {
      "color": _vm.themeColor,
      "status": "",
      "floating": "",
      "dark": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [_c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "touch": _vm.componenttouch,
      "space-id": _vm.spaceId,
      "include-owned-by-me": _vm.includeOwnedByMe,
      "limit": 10,
      "can-clear-space": _vm.canClearSpace,
      "with-header": false,
      "with-back": true,
      "mode": "out-in",
      "show-list-initially": _vm.showListInitially,
      "initial": _vm.initial,
      "page": _vm.page,
      "title": _vm.title
    },
    on: {
      "clientselected": _vm.clientSelected,
      "relationshipselected": _vm.relationshipSelected,
      "client:created": _vm.clientCreated,
      "componentchanged": _vm.setComponent,
      "back": function($event) {
        _vm.activeComponent = "ClientList"
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acc6c9ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/ClientPickerDialog.vue
// module id = 1510
// module chunks = 9